/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycProcessParticipantDto } from '../../models/kyc-process-participant-dto';

export interface GetAllByProcessId$Params {
  processId: string;
}

export function getAllByProcessId(http: HttpClient, rootUrl: string, params: GetAllByProcessId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KycProcessParticipantDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllByProcessId.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KycProcessParticipantDto>>;
    })
  );
}

getAllByProcessId.PATH = '/kyc/processes/{processId}/participants';
